import uni from "../styles/univesal.module.css";
import { header } from "./common";
import type {FaceCallback} from "@innovatrics/dot-face-auto-capture";
import FaceCamera from "../components/FaceCamera";
import FaceUi from "../components/FaceUi";
import { LangIds, Languages, getLang } from "../langs/langs";

interface Props {
  lang: Languages;
  headerNum: String;
  onFace: FaceCallback;
  onError: (error: Error) => void;
}

function FaceScan({lang, headerNum, onFace, onError}: Props) {

  const onFaceCallback: FaceCallback = async (imageData, content) => {
    onFace(imageData, content);
  };

  return (
    <>
      <div className={uni.container}>
        {header(getLang(LangIds.SCANFACE_Selfie, lang), headerNum)}
        <div className={uni.innerCameraContainer}>
          <FaceCamera
            cameraFacing="user"
            onPhotoTaken={onFaceCallback}
            onError={onError}
          />
          <FaceUi showCameraButtons
          instructions={{ candidate_selection: getLang(LangIds.SCANFACE_candidate_selection, lang), face_too_close: getLang(LangIds.SCANFACE_face_too_close, lang), face_too_far: getLang(LangIds.SCANFACE_face_too_far, lang), face_centering: getLang(LangIds.SCANFACE_face_centering, lang), face_not_present: getLang(LangIds.SCANFACE_face_not_present, lang), sharpness_too_low: getLang(LangIds.SCANFACE_sharpness_too_low, lang), brightness_too_low: getLang(LangIds.SCANFACE_brightness_too_low, lang), brightness_too_high: getLang(LangIds.SCANFACE_brightness_too_high, lang), device_pitched: getLang(LangIds.SCANFACE_device_pitched, lang) }}
          appStateInstructions={{ loading: { text: getLang(LangIds.SCANFACE_loading, lang), visible: true }, waiting: { text: getLang(LangIds.SCANFACE_waiting, lang), visible: true } }} />
        </div>
      </div>
    </>
  );
}

export default FaceScan;
